var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { injectIntl } from "@irati/utils/lang";
import NewItemStyles from "./styled/NewItem";
var Text = function (_a) {
    var text = _a.text, intl = _a.intl;
    return React.createElement("span", null, text || intl.formatMessage({ id: "recognition.feed.newItem" }));
};
var NewItem = styled.div.attrs({
    children: function (props) { return React.createElement(Text, __assign({}, props)); }
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), NewItemStyles);
export default injectIntl(NewItem);
var templateObject_1;
